import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { StaffService } from "../../staff-service/staff.service";
import * as moment from 'moment-timezone';
import { downloadBase64File } from "src/app/utils/pdf-downloader";
import { sweetAlert } from '../../../../utils/swal';
import Swal from 'sweetalert2';
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { takeUntil } from "rxjs/operators";
import { CsvService } from "src/app/service/csv-service/csv.service";
import { AuthService } from "src/app/service/auth-service/auth.service";

@Component({
  selector: "app-staff-timelines",
  templateUrl: "./staff-timelines.component.html",
  styleUrls: ["./staff-timelines.component.css"],
})
export class StaffTimelinesComponent implements OnInit, OnDestroy {
  user: any;
  search: string = "";
  staffList: any[] = [];
  selectedStaff: any;
  timeline: any;
  timelines: any;
  timelineEvents: any[] = [];
  isStaffTimedIn: boolean = false;
  view: string = 'today';
  isShowBreakPopup: boolean = false;
  applyCaTimeSheet: boolean = false;
  currentDateTime = moment().startOf('day');
  preDateRange = [
    moment().startOf('day'),
    moment().endOf('day')
  ];
  dateRange = [
    moment().startOf('day').toISOString(),
    moment().endOf('day').toISOString()
  ];
  break: any;

  timeZone: string;

  isHistoryData: boolean = false;
  isTodayData: boolean = false;
  isSelectedStaff: boolean = false;

  isBreakSubmitted: boolean = false;
  isTimelineSubmitted: boolean = false;
  breakDetail: boolean = false;
  editShift: boolean = false;
  showEditSessionModal: boolean = false;
  editingSession: any = null;
  isSessionSubmitted: boolean = false;
  showAddBreakModal: boolean = false;
  newBreak: any = { start: null, stop: null };
  isBreakFormSubmitted: boolean = false;
  isSavingBreak: boolean = false;
  isSavingSession: boolean = false;
  showAddSessionModal: boolean = false;
  newSession: any = { checkin: null, checkout: null };
  isSessionFormSubmitted: boolean = false;
  isEditingBreak: boolean = false;
  selectedBreak = {
    time: moment().set({ hours: 0, minutes: 5 }),
    min: moment().set({ hours: 0, minutes: 1 }),
    max: moment().set({ hours: 23, minutes: 59 }),
  };
  activeBreakCategory: 'rest' | 'meal' = 'rest';

  @ViewChild('btnCloseTimelineModal', { static: false }) btnClose: ElementRef;

  constructor(
    private staffService: StaffService,
    private sharedDataService: SharedDataService,
    private csvService: CsvService,
    public authService: AuthService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getStaffRole(staff: any): string {
    if (!staff) return '';
    const roleKey = staff.roles || staff.role;
    if (!roleKey) return '';
    if (Array.isArray(roleKey)) {
      return roleKey.map((r: any) => (this.authService && this.authService.staffComponentRoles && this.authService.staffComponentRoles[r]) || r).join(', ');
    }
    return (this.authService && this.authService.staffComponentRoles && this.authService.staffComponentRoles[roleKey]) || roleKey;
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.applyCaTimeSheet = this.user.applyCaTimeSheet;
          this.timeZone = this.user.timeZone;
          this.dateRange = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString()
          ];
          this.getStaffList();
        }
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.staffList = data.map((staff: any) => {
            staff.roleTitle = this.getStaffRole(staff);
            return staff;
          });
        }
      });
  }

  setView(view: string) {
    this.view = view;
    this.isShowBreakPopup = false;
    this.getStaffTimelines();
  }

  onSelectStaff(staff: any) {
    this.selectedStaff = staff;
    this.isShowBreakPopup = false;
    this.isBreakSubmitted = false;
    this.getStaffTimelines();
    this.closeView();
  }

  getStaffTimelines() {
    if (!this.selectedStaff) return;
    let queryString: any = {
      staff: this.selectedStaff._id
    };

    if (this.view === 'history') {
      queryString['dates'] = { startDate: this.dateRange[0], endDate: this.dateRange[1] };
    }

    this.staffService
      .getStaffTimelines(queryString)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          if (this.view === 'today') {
            this.timeline = data;
            this.buildTimelineEvents();
          } else if (this.view === 'history') {
            this.timelines = {};
            if (data.length) {
              this.timelines = data[0];
              if (this.timelines.jobs && this.timelines.jobs.length) {
                this.timelines.jobs.forEach((job: any) => {
                  const breakStats = this.calculateBreaksTakenAndDue(job.breaks);
                  job.mealTaken = breakStats.mealTaken;
                  job.restTaken = breakStats.restTaken;
                  job.mealDue = breakStats.mealDue;
                  job.restDue = breakStats.restDue;
                });
              }
            }
          }
        } else {
          this.timeline = undefined;
          this.timelines = undefined;
          this.timelineEvents = [];
        }
      });
  }

  showBreakPopup() {
    this.isShowBreakPopup = !this.isShowBreakPopup;
    if (this.isShowBreakPopup) {
      this.isBreakSubmitted = false;
      this.activeBreakCategory = 'rest';
      this.selectDuration(15);
    }
  }

  viewHourFormat(milli: number) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }

  calculateBreaksTakenAndDue(breaks: any[]) {
    let mealTaken = 0;
    let restTaken = 0;
    let mealDue = 0;
    let restDue = 0;
    const now = moment().tz(this.timeZone);

    if (breaks && breaks.length) {
      breaks.forEach((b) => {
        if (b.start && b.stop) {
          const stopTime = moment(b.stop).tz(this.timeZone);
          const isRest = b.status === 'rest' || (b.label && b.label.toLowerCase().includes('rest'));
          const isMeal = b.status === 'open' || b.status === 'approved' || (b.label && b.label.toLowerCase().includes('meal'));

          if (stopTime.isAfter(now)) {
            if (isRest) {
              restDue++;
            } else if (isMeal) {
              mealDue++;
            }
          } else {
            if (isRest) {
              restTaken++;
            } else if (isMeal) {
              mealTaken++;
            }
          }
        }
      });
    }

    return { mealTaken, restTaken, mealDue, restDue };
  }

  onChangeDate(evt: any) {
    this.dateRange = [
      evt[0].tz(this.timeZone).startOf('day').toISOString(),
      evt[1].tz(this.timeZone).endOf('day').toISOString()
    ];
    this.getStaffTimelines();
  }

  setBreakCategory(category: 'rest' | 'meal') {
    this.activeBreakCategory = category;
    if (category === 'meal') {
      this.selectDuration(-1);
    } else if (category === 'rest') {
      if (this.break === -1 || !this.break) {
        this.selectDuration(15);
      }
    }
  }

  selectDuration(value: any) {
    this.break = value;
  }

  getCustomTimeLabel(): string {
    if (this.selectedBreak && this.selectedBreak.time) {
      return moment(this.selectedBreak.time).format('HH:mm');
    }
    return '00:05';
  }

  getBreakPreview(): any {
    if (!this.break) return null;
    const now = moment().tz(this.timeZone);
    const startStr = now.format('hh:mm A');

    if (this.activeBreakCategory === 'meal' || this.break === -1) {
      return {
        label: `Open Meal Break`,
        type: 'Meal Break',
        durationText: 'Open / Indefinite',
        startTime: startStr,
        returnTime: 'Manual Return',
        helper: `Staff meal break will remain active until manually ended or clocked back in.`
      };
    }

    const breakTypeLabel = 'Rest Break';
    let mins = 0;
    if (this.break === 'custom') {
      const hours = moment(this.selectedBreak.time).hours();
      const minutes = moment(this.selectedBreak.time).minutes();
      mins = hours * 60 + minutes;
      if (!mins || mins <= 0) mins = 5;
    } else if (typeof this.break === 'number') {
      mins = this.break;
    }

    const returnTime = now.clone().add(mins, 'minutes').format('hh:mm A');
    const durationText = this.break === 'custom'
      ? (mins >= 60 ? `${Math.floor(mins / 60)}h ${mins % 60 ? (mins % 60) + 'm' : ''}`.trim() : `${mins} minutes`)
      : `${mins} minutes`;

    const label = this.break === 'custom'
      ? `Custom Rest Break (${durationText})`
      : `${mins} min Rest Break`;

    const helper = `Staff will be on rest break and is expected to return at ${returnTime}.`;

    return {
      label,
      type: breakTypeLabel,
      durationText,
      startTime: startStr,
      returnTime,
      helper
    };
  }

  saveBreak() {
    this.isBreakSubmitted = true;
    if (!this.break) return;

    if (this.activeBreakCategory === 'rest') {
      let totalMinutes = 0;
      if (this.break === 'custom') {
        const hours = moment(this.selectedBreak.time).hours();
        const minutes = moment(this.selectedBreak.time).minutes();
        totalMinutes = hours * 60 + minutes;
        if (totalMinutes < 1) totalMinutes = 5;
      } else if (typeof this.break === 'number' && this.break > 0) {
        totalMinutes = this.break;
      }
      this.action('rest', { value: totalMinutes || 15 });
    } else {
      // Meal break: only open option
      this.action('open');
    }
  }

  isRestBreakActive(breakItem: any): boolean {
    if (!breakItem || !breakItem._id || !breakItem.stop) return false;
    return moment(breakItem.stop).isAfter(moment());
  }

  checkBreak() {
    if (this.timeline) {
      const stop = moment().tz(this.timeZone);
      const lastBreak = this.timeline.breaks && this.timeline.breaks.length ? this.timeline.breaks[this.timeline.breaks.length - 1] : null;
      if (lastBreak) {
        if (!lastBreak.stop || lastBreak.status === 'open') {
          sweetAlert('Alert', 'Staff member is already on an active break.', 'warning', 'Ok');
          return true;
        }
        if (lastBreak.stop) {
          const lastBreakTimeEnd = moment(lastBreak.stop).tz(this.timeZone);
          if (moment.duration(lastBreakTimeEnd.diff(stop)).asSeconds() > 1) {
            sweetAlert('Alert', 'Staff member is already on a break. Break ends at ' + lastBreakTimeEnd.format('HHmm'), 'warning', 'Ok');
            return true;
          }
        }
      }
    }
    return false;
  }

  action(status: string, data?: any) {
    const staffId = (this.selectedStaff && (this.selectedStaff._id || this.selectedStaff.id || this.selectedStaff))
      || (this.timeline && this.timeline.staff && (this.timeline.staff._id || this.timeline.staff.id || this.timeline.staff));

    let payload: any = {
      staff: staffId
    };

    if (status === 'none') {
      // Check in
      payload.checkin = moment().tz(this.timeZone).toISOString();
    }

    if (status === 'completed') {
      // Check out (ends the day)
      payload.checkout = moment().tz(this.timeZone).toISOString();
      delete payload.break;
    }

    if (status === 'pause') {
      // Pause (check out, can check in again later)
      payload.checkout = moment().tz(this.timeZone).toISOString();
      payload.endShift = false;
    }

    if (status === 'open') {
      // Meal break started
      if (this.checkBreak()) {
        return;
      }
      payload.status = 'open';
      payload.break = {
        label: 'Meal break',
        status: 'open',
        start: moment().tz(this.timeZone).toISOString()
      };
    }

    if (status === 'rest') {
      // Rest break with start and stop
      if (this.checkBreak()) {
        return;
      }
      const start = moment().tz(this.timeZone);
      const minutes = (data && data.value) ? data.value : 10;
      const stop = start.clone().add(minutes, 'minutes');
      payload.status = 'rest';
      payload.break = {
        label: 'Rest break',
        status: 'rest',
        start: start.toISOString(),
        stop: stop.toISOString(),
        duration: moment.duration(stop.diff(start)).asMilliseconds()
      };
    }

    if (status === 'approved') {
      // Meal break with start and stop
      if (this.checkBreak()) {
        return;
      }
      let start = moment().tz(this.timeZone);
      let stop = moment().tz(this.timeZone).add(data.value, 'minutes');
      payload.status = 'approved';
      payload.break = {
        label: 'Meal break',
        status: 'approved',
        start: start.toISOString(),
        stop: stop.toISOString()
      };
    }

    if (status === 'close') {
      // End break
      let stop = moment().tz(this.timeZone);
      const duration = moment.duration(stop.diff(moment(data.start).tz(this.timeZone))).asMilliseconds();
      payload.status = 'approved';
      payload.break = {
        label: (data && data.label) || 'Meal break',
        status: 'approved',
        start: data.start,
        stop: stop.toISOString(),
        duration: duration > 0 ? duration : 0
      };
    }

    if (status === 'endRest') {
      // End an active rest break early
      payload.endBreak = { _id: data._id };
    }

    if (status === 'rejected') {
      payload.status = 'rejected';
      payload.break = {
        label: (data && data.label) || 'Break rejected',
        status: 'rejected',
        start: data.start,
        stop: moment().tz(this.timeZone).toISOString()
      };
    }

    this.sendRequest(payload);
  }

  sendRequest(payload: any) {
    sweetAlert('Alert', 'Are you sure you want to proceed?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.staffService
            .postStaffTimeline(payload)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe((data) => {
              if (data) {
                this.break = undefined;
                this.isShowBreakPopup = false;
                this.timeline = data;
                this.buildTimelineEvents();
                this.getStaffTimelines();
              }
            });
        }
      });
  }

  viewDetail(currentTimeline: any) {
    this.timeline = undefined;
    this.staffService
      .getStaffTimelineById(currentTimeline._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeline = data;
          this.buildTimelineEvents();
        }
      });
    this.breakHistory();
  }

  deleteDetail(currentTimeline: any) {
    sweetAlert('Alert', 'Are you sure you want to delete?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.staffService
            .deleteStaffTimelineById(currentTimeline._id)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe((data) => {
              if (data) {
                this.getStaffTimelines();
              }
            });
        }
      });
  }

  deleteLastSession(timeline: any) {
    sweetAlert('Alert', 'Deleting this entry will delete the timesheet history entry. Do you want to proceed?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.staffService
            .deleteStaffTimelineById(timeline._id)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe((data) => {
              if (data) {
                this.getStaffTimelines();
                this.closeView();
              }
            });
        }
      });
  }

  editDetail(currentTimeline: any) {
    this.timeline = undefined;
    this.isTimelineSubmitted = false;
    this.staffService
      .getStaffTimelineById(currentTimeline._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeline = data;
          this.buildTimelineEvents();
        }
      });
    this.shiftEdit();
  }

  saveTimeline() {
    this.isTimelineSubmitted = true;
    if (!this.timeline.checkin || !this.timeline.checkout) {
      return;
    }

    let start = moment(this.timeline.checkin).tz(this.timeZone);
    let stop = moment(this.timeline.checkout).tz(this.timeZone);

    const now = moment().tz(this.timeZone);
    if (start.isAfter(now)) {
      return sweetAlert('Alert', 'Time In cannot be after the current time', 'warning', 'Ok');
    }
    if (stop.isAfter(now)) {
      return sweetAlert('Alert', 'Time Out cannot be after the current time', 'warning', 'Ok');
    }

    if (!this.timeline._id && this.timelines && this.timelines.jobs) {
      const startDayStr = start.format('YYYY-MM-DD');
      const alreadyExists = this.timelines.jobs.some((job: any) => {
        return moment(job.checkin).tz(this.timeZone).format('YYYY-MM-DD') === startDayStr;
      });
      if (alreadyExists) {
        return sweetAlert('Alert', 'Timesheet entry already exists for this day.', 'warning', 'Ok');
      }
    }

    let duration = moment.duration(stop.diff(start));
    let breakTimeInMillis = 0;
    let isBreak = false;
    let lastBreakTimeEnd;
    if (this.timeline && this.timeline.breaks) {
      this.timeline.breaks.forEach((b: any) => {
        isBreak = false;
        if (b.status === 'approved') {
          lastBreakTimeEnd = moment(b.stop).tz(this.timeZone);
          if (moment.duration(lastBreakTimeEnd.diff(stop)).asSeconds() > 1) {
            isBreak = true;
          }
          let lastBreakTimeStart = moment(b.start).tz(this.timeZone);
          let bDuration = moment.duration(lastBreakTimeEnd.diff(lastBreakTimeStart));
          b.duration = bDuration.asMilliseconds();
          breakTimeInMillis += b.duration;
        }
      });
    }
    if (isBreak) {
      return sweetAlert('Alert', 'Staff member is already on a break. Break ends in ' + lastBreakTimeEnd.format('HHmm'), 'warning', 'Ok');
    }
    this.timeline.breakTimeInMillis = breakTimeInMillis || 0;
    this.timeline.workTimeInMillis = (duration.asMilliseconds() - breakTimeInMillis) || 0;
    this.timeline.checkin = start;
    this.timeline.checkout = stop;

    if (this.timeline._id) {
      this.saveTimelineRequest(this.timeline);
    } else {
      this.timeline.staff = this.selectedStaff._id;
      this.saveTimelineRequest(this.timeline);
    }
    this.editShift = false;
  }

  saveTimelineRequest(payload: any) {
    this.staffService
      .saveStaffTimeline(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        this.timeline = data;
        if (this.timelines) {
          this.getStaffTimelines();
        }
      });
  }

  addTimeSheet() {
    this.shiftEdit();
    this.isTimelineSubmitted = false;
    this.timeline = {
      checkin: null,
      checkout: null
    };
  }

  generateReport(type?: string) {
    let queryString: any = {};
    queryString['dates'] = { startDate: this.dateRange[0], endDate: this.dateRange[1] };
    if (type === 'staff') {
      queryString['staff'] = this.selectedStaff._id;
    }
    this.staffService
      .getStaffTimelinesReport(queryString)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data && data.length) {
          const res = data[0];
          if (res.content && res.pdfName) {
            downloadBase64File(res.content, res.pdfName);
          }
        }
      });
  }

  generateCSVReport() {
    const date = { startDate: this.dateRange[0], endDate: this.dateRange[1] };
    this.csvService.multiSheet(this.timelines, date, this.selectedStaff);
  }

  breakHistory() {
    this.breakDetail = true;
    this.editShift = false;
  }

  shiftEdit() {
    this.editShift = true;
    this.breakDetail = false;
  }

  deleteSession(session: any) {
    if (!this.timeline || !this.timeline.sessions) return;

    if (this.timeline.breaks && this.timeline.breaks.length) {
      const hasBreak = this.timeline.breaks.some((b: any) => {
        const breakTime = moment(b.start || b.updatedAt);
        const sessionCheckin = moment(session.checkin);
        const sessionCheckout = session.checkout ? moment(session.checkout) : null;
        return breakTime.isSameOrAfter(sessionCheckin) && (!sessionCheckout || breakTime.isBefore(sessionCheckout));
      });

      if (hasBreak) {
        return sweetAlert('Alert', 'This entry contains break(s) and cannot be deleted.', 'warning', 'Ok');
      }
    }

    sweetAlert('Alert', 'Are you sure you want to delete this time entry?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          const index = this.timeline.sessions.findIndex((s: any) => s._id === session._id);
          if (index > -1) {
            this.timeline.sessions.splice(index, 1);
          }

          this.buildTimelineEvents();
          const times = this.calculateWorkAndBreakTime();
          if (times.workTimeInMillis) {
            this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
          }
          this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

          if (this.timeline.sessions.length) {
            this.timeline.checkin = this.timeline.sessions[0].checkin;
            const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
            this.timeline.checkout = lastSession.checkout || null;
          }

          this.saveTimelineRequest(this.timeline);
          this.buildTimelineEvents();
        }
      });
  }

  deleteBreak(breakItem: any) {
    if (!this.timeline || !this.timeline.breaks) return;

    sweetAlert('Alert', 'Are you sure you want to delete the break?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          const index = this.timeline.breaks.findIndex((b: any) => {
            if (breakItem._id && b._id) {
              return b._id === breakItem._id;
            }
            return b.start === breakItem.start && b.stop === breakItem.stop;
          });

          if (index > -1) {
            this.timeline.breaks.splice(index, 1);
          }

          this.buildTimelineEvents();
          const times = this.calculateWorkAndBreakTime();
          if (times.workTimeInMillis) {
            this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
          }
          this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

          this.saveTimelineRequest(this.timeline);
          this.buildTimelineEvents();
        }
      });
  }

  checkBreakOverlap(startVal: any, stopVal: any, excludeBreakId?: string): boolean {
    if (!this.timeline || !this.timeline.breaks) return false;

    return this.timeline.breaks.some((b: any) => {
      if (excludeBreakId && b._id === excludeBreakId) {
        return false;
      }
      if (b.status !== 'approved' && b.status !== 'open' && b.status !== 'rest') return false;
      const bStart = moment(b.start).tz(this.timeZone);
      const bEnd = b.stop ? moment(b.stop).tz(this.timeZone) : null;
      if (bEnd) {
        return startVal.isBefore(bEnd) && bStart.isBefore(stopVal);
      }
      return bStart.isBefore(stopVal);
    });
  }

  openEditBreak(breakItem: any) {
    this.newBreak = JSON.parse(JSON.stringify(breakItem));
    this.isBreakFormSubmitted = false;
    this.isEditingBreak = true;
    this.showAddBreakModal = true;
  }

  updateBreak(startVal: any, stopVal: any) {
    if (!this.newBreak || !this.newBreak.start || !this.newBreak.stop) {
      return;
    }

    if (!this.timeline || !this.timeline.breaks) return;
    const index = this.timeline.breaks.findIndex((b: any) => b._id === this.newBreak._id);
    if (index > -1) {
      const duration = moment.duration(stopVal.diff(startVal));
      const durationInMinutes = Math.round(duration.asMinutes());

      this.timeline.breaks[index].start = startVal.toISOString();
      this.timeline.breaks[index].stop = stopVal.toISOString();
      this.timeline.breaks[index].duration = duration.asMilliseconds();
      this.timeline.breaks[index].value = durationInMinutes;
    }

    this.buildTimelineEvents();
    const times = this.calculateWorkAndBreakTime();
    if (times.workTimeInMillis) {
      this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
    }
    this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

    this.isSavingBreak = true;
    this.staffService
      .saveStaffTimeline(this.timeline)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          this.isSavingBreak = false;
          if (data) {
            this.timeline = data;
            this.buildTimelineEvents();
            this.getStaffTimelines();
            this.closeAddBreak();
          }
        },
        () => {
          this.isSavingBreak = false;
        }
      );
  }

  openEditSession(session: any) {
    this.editingSession = JSON.parse(JSON.stringify(session));
    this.isSessionSubmitted = false;
    this.showEditSessionModal = true;
  }

  isDateDifferent(date1: any, date2: any): boolean {
    if (!date1 || !date2) return false;
    return !moment(date1).tz(this.timeZone).isSame(moment(date2).tz(this.timeZone), 'minute');
  }

  isAnyOverlayOpen(): boolean {
    return (
      this.showEditSessionModal ||
      this.showAddBreakModal ||
      this.showAddSessionModal ||
      (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible())
    );
  }

  closeEditSession() {
    if (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible()) return;
    setTimeout(() => {
      this.showEditSessionModal = false;
      this.editingSession = null;
    }, 0);
  }

  updateSession() {
    this.isSessionSubmitted = true;
    if (!this.editingSession || !this.editingSession.checkin) {
      return;
    }

    if (!this.timeline || !this.timeline.sessions) return;
    const index = this.timeline.sessions.findIndex((s: any) => s._id === this.editingSession._id);
    if (index > -1) {
      let checkinVal = moment(this.editingSession.checkin).tz(this.timeZone);
      let checkoutVal = this.editingSession.checkout ? moment(this.editingSession.checkout).tz(this.timeZone) : null;

      if (checkoutVal && moment.duration(checkoutVal.diff(checkinVal)).asSeconds() < 0) {
        return sweetAlert('Alert', 'Time Out cannot be before Time In', 'warning', 'Ok');
      }

      const now = moment().tz(this.timeZone);
      if (checkinVal.isAfter(now)) {
        return sweetAlert('Alert', 'Time In cannot be after the current time', 'warning', 'Ok');
      }
      if (checkoutVal && checkoutVal.isAfter(now)) {
        return sweetAlert('Alert', 'Time Out cannot be after the current time', 'warning', 'Ok');
      }

      if (this.checkOverlap(checkinVal, checkoutVal, this.editingSession._id)) {
        return sweetAlert('Alert', 'This session overlaps with an existing session.', 'warning', 'Ok');
      }

      if (this.timeline.breaks && this.timeline.breaks.length) {
        const completedBreaks = this.timeline.breaks.filter((b: any) => b.start && b.stop);

        if (completedBreaks.length) {
          const sorted = [...completedBreaks].sort(
            (a, b) => moment(a.start).valueOf() - moment(b.start).valueOf()
          );

          const firstBreak = sorted[0];
          const firstBreakStart = moment(firstBreak.start).tz(this.timeZone);
          if (checkinVal.isAfter(firstBreakStart)) {
            const formatted = firstBreakStart.format('HHmm');
            return sweetAlert('Alert', `Time In cannot be after the break start (${formatted}).`, 'warning', 'Ok');
          }

          if (checkoutVal) {
            const lastBreak = sorted[sorted.length - 1];
            const lastBreakStop = moment(lastBreak.stop).tz(this.timeZone);
            if (checkoutVal.isBefore(lastBreakStop)) {
              const formatted = lastBreakStop.format('HHmm');
              return sweetAlert('Alert', `Time Out cannot be before the break end (${formatted}).`, 'warning', 'Ok');
            }
          }

          if (!checkoutVal) {
            const overlappingBreak = sorted.find((b: any) => {
              const bStart = moment(b.start).tz(this.timeZone);
              const bStop = moment(b.stop).tz(this.timeZone);
              return checkinVal.isSameOrAfter(bStart) && checkinVal.isBefore(bStop);
            });
            if (overlappingBreak) {
              const bStart = moment(overlappingBreak.start).tz(this.timeZone).format('HHmm');
              const bStop = moment(overlappingBreak.stop).tz(this.timeZone).format('HHmm');
              return sweetAlert('Alert', `Time In overlaps with an existing break (${bStart} – ${bStop}).`, 'warning', 'Ok');
            }
          }
        }
      }

      this.timeline.sessions[index].checkin = checkinVal;
      this.timeline.sessions[index].checkout = checkoutVal;

      this.buildTimelineEvents();
      const times = this.calculateWorkAndBreakTime();
      if (times.workTimeInMillis) {
        this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
      }
      this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

      if (this.timeline.sessions.length) {
        this.timeline.checkin = this.timeline.sessions[0].checkin;
        const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
        this.timeline.checkout = lastSession.checkout || null;
      }

      this.saveTimelineRequest(this.timeline);
      this.buildTimelineEvents();
      this.closeEditSession();
    }
  }

  openAddBreak() {
    this.newBreak = {
      start: null,
      stop: null
    };
    this.isBreakFormSubmitted = false;
    this.showAddBreakModal = true;
  }

  closeAddBreak() {
    if (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible()) return;
    setTimeout(() => {
      this.showAddBreakModal = false;
      this.newBreak = { start: null, stop: null };
      this.isEditingBreak = false;
    }, 0);
  }

  saveNewBreak() {
    this.isBreakFormSubmitted = true;
    if (!this.newBreak.start || !this.newBreak.stop) {
      return;
    }

    let startVal = moment(this.newBreak.start).tz(this.timeZone);
    let stopVal = moment(this.newBreak.stop).tz(this.timeZone);

    if (!this.isEditingBreak && this.timeline && this.timeline.checkin) {
      let baseDate = moment(this.timeline.checkin).tz(this.timeZone);
      startVal = baseDate.clone().hours(startVal.hours()).minutes(startVal.minutes()).seconds(0).milliseconds(0);
      stopVal = baseDate.clone().hours(stopVal.hours()).minutes(stopVal.minutes()).seconds(0).milliseconds(0);
    }

    if (moment.duration(stopVal.diff(startVal)).asSeconds() <= 0) {
      return sweetAlert('Alert', 'Stop Time cannot be before or equal to Start Time', 'warning', 'Ok');
    }

    const isWithinAnySession = this.timeline && this.timeline.sessions && this.timeline.sessions.some((s: any) => {
      const sessionStart = moment(s.checkin).tz(this.timeZone);
      const sessionEnd = s.checkout ? moment(s.checkout).tz(this.timeZone) : null;
      return startVal.isSameOrAfter(sessionStart) && (!sessionEnd || stopVal.isSameOrBefore(sessionEnd));
    });

    if (!isWithinAnySession) {
      return sweetAlert('Alert', 'Break must fall within existing time entries.', 'warning', 'Ok');
    }

    if (this.checkBreakOverlap(startVal, stopVal, this.isEditingBreak ? this.newBreak._id : undefined)) {
      return sweetAlert('Alert', 'Break overlaps with an existing break.', 'warning', 'Ok');
    }

    if (this.isEditingBreak) {
      this.updateBreak(startVal, stopVal);
    } else {
      this.saveBreakFromTimeline(startVal, stopVal);
    }
  }

  saveBreakFromTimeline(startVal: any, stopVal: any) {
    const duration = moment.duration(stopVal.diff(startVal));
    const durationInMinutes = Math.round(duration.asMinutes());
    const isRest = durationInMinutes <= 15;

    let payload: any = {
      staff: this.selectedStaff._id,
      status: isRest ? 'rest' : 'approved',
      break: {
        label: isRest ? 'Rest break' : 'Meal break',
        status: isRest ? 'rest' : 'approved',
        start: startVal.toISOString(),
        stop: stopVal.toISOString()
      }
    };

    sweetAlert('Alert', 'Are you sure you want to proceed?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.isSavingBreak = true;
          this.staffService
            .postStaffTimeline(payload)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(
              (data) => {
                this.isSavingBreak = false;
                if (data) {
                  this.showAddBreakModal = false;
                  this.newBreak = { start: null, stop: null };
                  this.timeline = data;
                  this.buildTimelineEvents();
                  this.getStaffTimelines();
                }
              },
              () => {
                this.isSavingBreak = false;
              }
            );
        }
      });
  }

  openAddSession() {
    this.newSession = {
      checkin: null,
      checkout: null
    };
    this.isSessionFormSubmitted = false;
    this.showAddSessionModal = true;
  }

  closeAddSession() {
    if (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible()) return;
    setTimeout(() => {
      this.showAddSessionModal = false;
      this.newSession = { checkin: null, checkout: null };
    }, 0);
  }

  checkOverlap(checkin: any, checkout: any, excludeSessionId?: string): boolean {
    if (!this.timeline || !this.timeline.sessions) return false;

    const newStart = moment(checkin).tz(this.timeZone);
    const newEnd = moment(checkout).tz(this.timeZone);

    return this.timeline.sessions.some((s: any) => {
      if (excludeSessionId && s._id === excludeSessionId) {
        return false;
      }
      const existStart = moment(s.checkin).tz(this.timeZone);
      const existEnd = s.checkout ? moment(s.checkout).tz(this.timeZone) : null;

      if (existEnd) {
        return newStart.isBefore(existEnd) && existStart.isBefore(newEnd);
      } else {
        return existStart.isBefore(newEnd);
      }
    });
  }

  saveNewSession() {
    this.isSessionFormSubmitted = true;
    if (!this.newSession.checkin || !this.newSession.checkout) {
      return;
    }

    let checkinVal = moment(this.newSession.checkin).tz(this.timeZone);
    let checkoutVal = moment(this.newSession.checkout).tz(this.timeZone);

    if (this.timeline && this.timeline.checkin) {
      let baseDate = moment(this.timeline.checkin).tz(this.timeZone);
      checkinVal = baseDate.clone().hours(checkinVal.hours()).minutes(checkinVal.minutes()).seconds(0).milliseconds(0);
      checkoutVal = baseDate.clone().hours(checkoutVal.hours()).minutes(checkoutVal.minutes()).seconds(0).milliseconds(0);
    }

    if (moment.duration(checkoutVal.diff(checkinVal)).asSeconds() <= 0) {
      return sweetAlert('Alert', 'Time Out cannot be before or equal to Time In', 'warning', 'Ok');
    }

    const now = moment().tz(this.timeZone);
    if (checkinVal.isAfter(now)) {
      return sweetAlert('Alert', 'Time In cannot be after the current time', 'warning', 'Ok');
    }
    if (checkoutVal.isAfter(now)) {
      return sweetAlert('Alert', 'Time Out cannot be after the current time', 'warning', 'Ok');
    }

    if (this.checkOverlap(checkinVal, checkoutVal)) {
      return sweetAlert('Alert', 'This session overlaps with an existing session.', 'warning', 'Ok');
    }

    if (!this.timeline) return;
    if (!this.timeline.sessions) {
      this.timeline.sessions = [];
    }

    this.timeline.sessions.push({
      checkin: checkinVal.toISOString(),
      checkout: checkoutVal.toISOString()
    });

    this.timeline.sessions.sort((a: any, b: any) => {
      return new Date(a.checkin).getTime() - new Date(b.checkin).getTime();
    });

    this.buildTimelineEvents();
    const times = this.calculateWorkAndBreakTime();
    if (times.workTimeInMillis) {
      this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
    }
    this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

    if (this.timeline.sessions.length) {
      this.timeline.checkin = this.timeline.sessions[0].checkin;
      const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
      this.timeline.checkout = lastSession.checkout || null;
    }

    this.isSavingSession = true;
    this.staffService
      .saveStaffTimeline(this.timeline)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          this.isSavingSession = false;
          if (data) {
            this.timeline = data;
            this.buildTimelineEvents();
            this.getStaffTimelines();
            this.closeAddSession();
          }
        },
        () => {
          this.isSavingSession = false;
        }
      );
  }

  closeView() {
    if (this.isAnyOverlayOpen()) return;
    this.isShowBreakPopup = false;
    this.breakDetail = false;
    this.editShift = false;
    this.showEditSessionModal = false;
    this.showAddBreakModal = false;
    this.showAddSessionModal = false;
  }

  buildTimelineEvents() {
    if (!this.timeline) {
      this.timelineEvents = [];
      this.isStaffTimedIn = false;
      return;
    }

    if (this.timeline.sessions && this.timeline.sessions.length) {
      const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
      this.isStaffTimedIn = !!(lastSession && lastSession.checkin && !lastSession.checkout);
    } else {
      this.isStaffTimedIn = !!(this.timeline.checkin && !this.timeline.checkout);
    }

    const events: any[] = [];

    if (this.timeline.sessions && this.timeline.sessions.length) {
      this.timeline.sessions.forEach((session: any) => {
        if (session.checkin) {
          events.push({
            type: 'checkin',
            sortTime: session.checkin,
            data: session
          });
        }
        if (session.checkout) {
          events.push({
            type: 'checkout',
            sortTime: session.checkout,
            data: session
          });
        }
      });
    }

    if (this.timeline.breaks && this.timeline.breaks.length) {
      this.timeline.breaks.forEach((b: any) => {
        events.push({
          type: 'break',
          sortTime: b.start || b.updatedAt,
          data: b
        });
      });
    }

    events.sort((a, b) => {
      return new Date(a.sortTime).getTime() - new Date(b.sortTime).getTime();
    });

    this.timelineEvents = events;
  }

  calculateWorkAndBreakTime() {
    let workTimeInMillis = 0;
    let breakTimeInMillis = 0;

    if (this.timelineEvents && this.timelineEvents.length > 0) {
      let stopSumming = false;
      for (const event of this.timelineEvents) {
        if (stopSumming) {
          break;
        }

        if (event.type === 'checkin' && !event.data.checkout) {
          stopSumming = true;
        } else if (event.type === 'checkout') {
          const start = moment(event.data.checkin).tz(this.timeZone);
          const stop = moment(event.data.checkout).tz(this.timeZone);
          workTimeInMillis += moment.duration(stop.diff(start)).asMilliseconds();
        } else if (event.type === 'break') {
          if (event.data.duration) {
            breakTimeInMillis += event.data.duration;
          }
        }
      }
    }

    return { workTimeInMillis, breakTimeInMillis };
  }

  ngOnDestroy(): void {
  }
}
